import { useState } from "react";
import type { ScheduleEntry } from "@edu/shared";
import * as api from "../../lib/api.ts";

/**
 * «Отменить запись» у ученика на занятии, на которое он записался сам
 * (`docs/booking-design.md`, 1.7 и 3.2).
 *
 * Кнопка есть только при `cancellableByMe`: урок создан его записью и ещё не
 * начался. Сервер проверяет то же самое заново, поле нужно, чтобы решить, где
 * рисовать кнопку.
 *
 * ⚠️ **Подтверждение в самой карточке, двумя шагами, а не `confirm()`**, как у
 * отмены занятия преподавателем (`CancelOccurrenceForm`): системного окна в
 * продукте нет нигде, и первое нажатие только раскрывает, что произойдёт.
 *
 * ⚠️ Что станет со временем после отмены, здесь НЕ обещается. Время снова
 * откроется, только если преподаватель занятие не переносил (1.7 проекта), и
 * «время освободится для других» было бы неправдой ровно у перенесённого.
 */
export function BookingCancel({
  entry,
  busy,
  run,
}: {
  entry: ScheduleEntry;
  busy: boolean;
  run: (fn: () => Promise<void>) => Promise<void>;
}) {
  const [asking, setAsking] = useState(false);
  const lessonId = entry.lessonId;
  if (entry.cancellableByMe !== true || lessonId === null) return null;

  if (!asking) {
    return (
      <button type="button" className="btn" disabled={busy} onClick={() => setAsking(true)}>
        Отменить запись
      </button>
    );
  }
  return (
    <div className="note">
      <p>Занятие пропадёт из расписания у вас и у преподавателя.</p>
      <div className="form__foot">
        <button
          type="button"
          className="btn btn--quiet"
          disabled={busy}
          onClick={() => setAsking(false)}
        >
          Не надо
        </button>
        <button
          type="button"
          className="btn btn--danger is-confirm"
          disabled={busy}
          onClick={() => void run(() => api.cancelBooking(lessonId))}
        >
          Отменить запись
        </button>
      </div>
    </div>
  );
}
